export default __webpack_public_path__ + "static/media/logo_nigel_dark.949e2b2e.svg";